import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, NgForm, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router"
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, Observer } from 'rxjs';

import { LaboratorioService } from '../../../services/laboratorio.service';

@Component({
    selector: 'app-lancamento-laboratorio',
    templateUrl: './lancamento-laboratorio.component.html',
    styleUrls: ['./lancamento-laboratorio.component.css'],
    standalone: false
})
export class LancamentoLaboratorioComponent implements OnInit {
  laboratorioForm!: UntypedFormGroup;
  idlaboratorio = null;
  dataLaboratorioAtt = null;

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
    private laboratorioService: LaboratorioService,
  ) { 
    this.laboratorioForm = this.newFormLaboratorio();

    this.route.params.subscribe(res => this.idlaboratorio = res.idlaboratorio);
  }

  ngOnInit(): void {
    if (this.idlaboratorio !== undefined) {
      this.laboratorioService.detalhar(this.idlaboratorio).subscribe((p: any) => {
        let item = p.data.laboratorio;
        this.dataLaboratorioAtt = item;
        this.laboratorioForm.get('idlaboratorio').setValue(item.idlaboratorio);
        this.laboratorioForm.get('descricao').setValue(item.descricao);
      });
    } else {
      this.laboratorioForm.reset();
    }
  }

  newFormLaboratorio() {
    return new UntypedFormGroup({
      idlaboratorio: new UntypedFormControl(''),
      descricao: new UntypedFormControl('', [Validators.required]),
    });
  }

  onSubmitLaboratorio() {
    if (this.laboratorioForm.valid) {
      let id = this.message.loading('Salvando cadastro...').messageId;
      if (this.idlaboratorio !== undefined) {
        let dadosEdicao = this.laboratorioForm.value;

        this.laboratorioService.atualizar(dadosEdicao).subscribe((p: any) => {
          this.router.navigate(['/laboratorio']);
          this.message.remove(id);
          this.message.success('O laboratório foi atualizado com SUCESSO!');
        });

      } else {
        this.laboratorioService.criar(this.laboratorioForm.value).subscribe((p: any) => {
          this.message.remove(id);
          this.router.navigate(['/laboratorio']);
          this.message.success('O laboratório foi cadastrado com SUCESSO!');
        });
      }

    } else {
      for (const i in this.laboratorioForm.controls) {
        this.laboratorioForm.controls[i].markAsDirty();
        this.laboratorioForm.controls[i].updateValueAndValidity();
      }
    }
  }
}
